import React, { useEffect, useState } from "react";
import {
  Layout,
  Card,
  Tag,
  Button,
  Image,
  Typography,
  Spin,
  message,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { BASE_URL } from "../Config";
import axios from "axios";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const ViewVariation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [variation, setVariation] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch Variation
  useEffect(() => {
    fetchVariation();
  }, []);

  const fetchVariation = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const json = res.data;
      const v = json.variation || json;

      if (!v) {
        message.error("Variation not found");
        return;
      }

      setVariation(v);
      setLoading(false);
    } catch (err) {
      console.log(err);
      message.error("Failed to fetch variation");
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 120 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout
        style={{
          marginLeft: 200,
          marginTop: 70,
        }}
      >
        <Content style={{ padding: "30px" }}>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/my-variation")}
            style={{ marginBottom: 20 }}
          >
            Back
          </Button>

          <Card
            bordered={false}
            style={{
              maxWidth: 900,
              margin: "0 auto",
              borderRadius: 12,
              padding: 20,
            }}
          >
            <div style={{ textAlign: "center", marginBottom: 30 }}>
              <Image
                src={variation?.image}
                width={350}
                style={{
                  borderRadius: 12,
                  objectFit: "cover",
                }}
              />
            </div>

            <Title level={2} style={{ textAlign: "center", marginBottom: 20 }}>
              {variation?.name}
            </Title>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginBottom: 20,
              }}
            >
              <Text>
                <strong>Sanskrit : </strong> {variation?.sanskrit}
              </Text>

              <Text>
                <strong>Country : </strong> {variation?.country}
              </Text>

              <Text>
                <strong>English : </strong> {variation?.english}
              </Text>

              <div>
                <strong>Pose Type:</strong>{" "}
                {variation?.poseType?.map((t, i) => (
                  <Tag color="blue" key={i} style={{ marginBottom: 5 }}>
                    {t}
                  </Tag>
                ))}
              </div>

              <div>
                <strong>Parent Asana:</strong>{" "}
                <Tag color="green" style={{ textTransform: "capitalize" }}>
                  {variation?.parentAsana?.name}
                </Tag>
              </div>
              <Text>
                <strong>Media Link : </strong>
                <a href={variation?.mediaLink} target="blank">{variation?.mediaLink}</a>
              </Text>
            </div>
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ViewVariation;
